import { Link } from "react-router-dom";

export const AccessibilityButton = () => {
  return (
    <Link
      to="/accessibility"
      className="fixed bottom-5 left-5 z-50 flex items-center justify-center w-14 h-14 bg-brand hover:bg-brand-light rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-105"
      data-testid="floating-accessibility-button"
      aria-label="Accessibility Statement"
      title="Accessibility"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="currentColor" 
        className="w-7 h-7 text-white"
      >
        <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"/>
      </svg>
    </Link>
  );
};

export default AccessibilityButton;
